module.exports = __webpack_public_path__ + "fonts/g9iYs0hV.woff2";